import type { AuthSettings } from "@entrilia/shared/auth/authTypes";
import { initAuthSettings } from "@entrilia/shared/auth/settings";
import { importEnvVariable } from "@entrilia/shared/variables";

interface EnvVariables {
  LOGIN_APP_URI: string;
}

let variables: EnvVariables | undefined = undefined;

const importVariables = () => ({
  LOGIN_APP_URI: importEnvVariable("REACT_APP_LOGIN_APP_URI"),
});

export const getVariables = (): EnvVariables => {
  if (variables === undefined) {
    variables = importVariables();
  }
  return variables;
};

type AuthMode = "end_user" | "impersonation";

let currentAuthMode: AuthMode = "end_user";

export const getAuthMode = () => currentAuthMode;

export const setAuthMode = (mode: AuthMode) => {
  currentAuthMode = mode;
  initAuthSettings(mode === "impersonation" ? importImpersonationAuthSettings() : importEndUserAuthSettings());
};

const importEndUserAuthSettings = (): AuthSettings => ({
  authEndpoint: importEnvVariable("REACT_APP_INVESTOR_PORTAL_AUTH_ENDPOINT"),
  userFlowSignIn: importEnvVariable("REACT_APP_INVESTOR_PORTAL_USER_FLOW_SIGNIN"),
  userFlowSignUp: importEnvVariable("REACT_APP_INVESTOR_PORTAL_USER_FLOW_SIGNUP"),
  userFlowPasswordReset: importEnvVariable("REACT_APP_INVESTOR_PORTAL_USER_FLOW_PASSWORD_RESET"),
  clientId: importEnvVariable("REACT_APP_INVESTOR_PORTAL_CLIENT_ID"),
  portalAccessScope: importEnvVariable("REACT_APP_INVESTOR_PORTAL_ACCESS_SCOPE"),
  authCookieNames: "x-entrilia-ir-authorized",
  refreshCookieNames: "x-entrilia-ir-refresh-available",
  cookieTarget: "ir",
});

const importImpersonationAuthSettings = (): AuthSettings => ({
  authEndpoint: "",
  userFlowSignIn: "",
  userFlowSignUp: "",
  userFlowPasswordReset: "",
  clientId: importEnvVariable("REACT_APP_ADMIN_PORTAL_CLIENT_ID"),
  portalAccessScope: importEnvVariable("REACT_APP_ADMIN_PORTAL_ACCESS_SCOPE"),
  authCookieNames: "x-entrilia-ap-authorized",
  refreshCookieNames: "x-entrilia-ap-refresh-available",
  cookieTarget: "ap",
});
